import React from 'react';
import { Link } from 'react-router-dom';
import { BrandLockup } from '@/components/brand/BrandMark';

export default function TermsPage() {
  return (
    <div className="min-h-screen bg-background">
      <header className="border-b border-border px-6 py-4">
        <Link to="/"><BrandLockup /></Link>
      </header>
      <main className="max-w-3xl mx-auto px-6 py-10 space-y-6">
        <div>
          <p className="text-sm text-muted-foreground">Effective August 16, 2026</p>
          <h1 className="text-2xl font-semibold mt-1">Terms of Service</h1>
        </div>

        <section className="space-y-2">
          <h2 className="text-lg font-medium">Bookings and service</h2>
          <p className="text-sm text-muted-foreground">
            Submitting a booking request or using the customer portal is a request.
            Service is accepted only when FlexiClean confirms it. Customers are
            responsible for accurate property information, lawful access, safe
            conditions, and timely disclosure of hazards, pets, or restrictions.
          </p>
        </section>

        <section className="space-y-2">
          <h2 className="text-lg font-medium">Text (SMS) messaging</h2>
          <p className="text-sm text-muted-foreground">
            Customers may opt in to receive service texts (appointment and arrival
            updates, invoices, payment reminders) tied to an active booking.
            Message frequency varies with your active bookings; message and data
            rates may apply. Reply STOP to opt out at any time, or HELP for help.
            See the <Link to="/privacy" className="text-primary underline">Privacy Policy</Link> for
            how mobile information is used.
          </p>
        </section>

        <section className="space-y-2">
          <h2 className="text-lg font-medium">Quality concerns</h2>
          <p className="text-sm text-muted-foreground">
            If a service concern arises, contact FlexiClean promptly with the job
            date and details. Any re-clean, refund, credit, or other remedy depends
            on the confirmed service terms and the circumstances of that job.
          </p>
        </section>

        <section className="space-y-2">
          <h2 className="text-lg font-medium">Acceptable use</h2>
          <p className="text-sm text-muted-foreground">
            Do not misuse the portal, attempt unauthorized access, submit unlawful
            or deceptive material, or interfere with availability.
          </p>
        </section>

        <section className="space-y-2">
          <h2 className="text-lg font-medium">Florida law and changes</h2>
          <p className="text-sm text-muted-foreground">
            These terms are governed by Florida law, without overriding mandatory
            consumer protections. We may update them as our practices change; the
            effective date above identifies the current version.
          </p>
        </section>

        <section className="space-y-2">
          <h2 className="text-lg font-medium">Contact</h2>
          <p className="text-sm text-muted-foreground">
            Questions can be sent to{' '}
            <a href="mailto:info@flexicleanpro.com" className="text-primary underline">info@flexicleanpro.com</a>{' '}
            or <a href="tel:+18509057223" className="text-primary underline">(850) 905-7223</a>.
          </p>
        </section>
      </main>
    </div>
  );
}
